<template>
	<div class="camera-switch-panel">
		<v-btn icon @click="set3DView" title="3D View" :class="{ 'active-button': activeView === '3d' }"
			:disabled="isDrawing2DImageForce2D">
			<v-icon>mdi-rotate-3d</v-icon>
		</v-btn>
		<v-btn icon @click="setTopView" title="Top View" :class="{ 'active-button': activeView === 'top' }">
			<v-icon>mdi-arrow-down-bold-box-outline</v-icon>
		</v-btn>
	</div>
</template>

<script>
import { mapState } from "vuex";
import { InProgressMode } from "@/store/modules/inprogress-mode-manager";

export default {
	name: "CameraSwitchPanel",
	computed: {
		...mapState(["currentView"]),
		...mapState("drawing2dImage", ["isTwoPointAlignment", "imageUnderEdit"]),
		...mapState("inProgressModeManager", ["inProgressMode", "objectType"]),

		// Drawing2DImageの生成・編集中かどうかを判定
		isDrawing2DImageForce2D() {
			return (
				// Creating Drawing2DImage
				(this.inProgressMode === InProgressMode.CREATION &&
					this.objectType === "Drawing2DImage") ||
				// Editing Drawing2DImage
				this.imageUnderEdit !== null ||
				// Editing twoPointAlignment
				this.isTwoPointAlignment
			);
		},
		// Editing temporary road, flat ground, trench, etc.
		isInEditMode() {
			return this.inProgressMode === InProgressMode.EDIT;
		},
		activeView() {
			return this.isDrawing2DImageForce2D ? "top" : this.currentView;
		},
	},
	watch: {
		// Watching the change of Drawing2DImage editing status
		isDrawing2DImageForce2D(newVal, oldVal) {
			if (newVal && !oldVal) {
				// Drawing2DImage editing started or twoPointAlignment started
				this.$store.dispatch("setCurrentView", "top");
			} else if (!newVal && oldVal) {
				// Drawing2DImage editing ended or twoPointAlignment ended
				this.$store.dispatch("setCurrentView", "3d");
			}
		},
		// Watching the change of general editing mode (temporary road, flat ground, trench, etc.)
		isInEditMode(newVal, oldVal) {
			if (!newVal && oldVal) {
				// Editing ended (temporary road, flat ground, trench, etc.)
				this.$store.dispatch("setCurrentView", "3d");
			}
		},
	},
	mounted() {
		// If Drawing2DImage is being edited or twoPointAlignment is being edited, set the 2D icon to active
		if (this.isDrawing2DImageForce2D) {
			this.$store.dispatch("setCurrentView", "top");
		}
	},
	methods: {
		set3DView() {
			// If Drawing2DImage is being edited or twoPointAlignment is being edited, do not switch to 3D view
			if (this.isDrawing2DImageForce2D) {
				return;
			}
			this.$store.dispatch("setCurrentView", "3d");
		},
		setTopView() {
			this.$store.dispatch("setCurrentView", "top");
		},
	},
};
</script>

<style scoped>
.camera-switch-panel {
	position: absolute;
	top: 10px;
	left: 10px;
	z-index: 1;
	display: flex;
	flex-direction: row;
	gap: 8px;
	background-color: rgba(0, 0, 0, 0.5);
	padding: 8px;
	border-radius: 4px;
}

.camera-switch-panel .v-btn {
	min-width: 36px;
	width: 36px;
	height: 36px;
	background-color: rgba(50, 50, 50, 0.7);
	border: 1px solid rgba(100, 100, 100, 0.9);
	color: white;
}

.camera-switch-panel .v-btn:hover:not(.active-button):not(:disabled) {
	background-color: rgba(70, 70, 70, 0.8);
}

.camera-switch-panel .v-btn.active-button {
	background-color: #1976D2;
}

.camera-switch-panel .v-btn:disabled {
	background-color: rgba(30, 30, 30, 0.5);
	border-color: rgba(60, 60, 60, 0.5);
	opacity: 0.4;
}

.camera-switch-panel .v-icon {
	color: white;
}

.camera-switch-panel .v-btn:disabled .v-icon {
	color: rgba(255, 255, 255, 0.3);
}
</style>
